export const defaultTranslations = {
  yes: "Yes",
  no: "No",
  loadMore: "Load more",
  loading: "Loading...",
  noOptions: "No options",
  hello: "Hello",
  submit: "Submit",
  cancel: "Cancel",
  close: "Close",
  delete: "Delete",
  save: "Save",
  confirm: "Confirm",
  or: "or",
  search: "Search",
  clearSearch: "Clear search",
  value: "Value",
  sortBy: "Sort by",
  none: "None",
  previous: "Previous",
  next: "Next",
  pagination: "Pagination",
  goToPage: "Go to page {{page}}",
  currentPage: "page {{page}}",
  goToPreviousPage: "Go to previous page",
  goToNextPage: "Go to next page",
  goToFirstPage: "Go to first page",
  goToLastPage: "Go to last page",
  uploadPicture: "Upload picture",
  removePicture: "Remove picture",
  fileUploadedSuccessfully: "File uploaded successfully",
  reject: "Reject",
  accept: "Accept",
  transactionAccepted: "Transaction accepted",
  transactionRejected: "Transaction rejected",
  acceptTransaction: "Accept transaction",
  rejectTransaction: "Reject transaction",
  pictureShouldHasOnly2Mb: "File too big. You can upload files to 2Mb",
  findMoreHere: "Find more pricing suggestions <Link>here!</Link>",
  moreCount: "+{{count}} more",
}
